import { z } from "zod";
import { ZProjectNo } from "./foundationSchema";
export const ZDrofusArticleDetailsRequest = z.object({
    projectNo: ZProjectNo,
    articleNumber: z.string().trim().min(1),
});
export const ZDrofusArticleField = z.object({
    id: z.string(),
    name: z.string(),
    propertyGroup: z.string(),
    dataType: z.string(),
    unit: z.string().optional(),
});
export const ZDrofusArticleDetailsResponse = z.object({
    articleNumber: z.string(),
    fetchedAt: z.string().datetime(),
    fields: z.array(ZDrofusArticleField),
    article: z.record(z.string(), z.unknown()).nullable(),
});
